const PrimaryRadioSelection = [
    { span: 8, height: "45px", classes: "marginTop-8" },
    { span: 12, height: "74px", classes: "marginTop-16" },
    { span: 12, height: "74px", classes: "marginTop-16" },
]
export default PrimaryRadioSelection
